<template>
  <!-- 评分卡详情 -->
  <div class="score-card-detail">
    <a-card :loading="loading" class="card">
      <div class="text-right">
        <a-button
          style="margin-right:20px;"
          type="primary"
          @click="_exportScoreCard"
        >
          导出
        </a-button>
        <a-button @click="goBack">返回上一页</a-button>
      </div>
      <card-view
        :schema="SCORE_DETAIL_SCHEMA"
        :source-data="score"
        :column="column"
      ></card-view>
    </a-card>
    <score-table
      v-if="this.cardType != 0"
      :loading="loading"
      :flag="flag"
      :originalData="originalData"
      :scoreData="score"
      :cardType="1"
    ></score-table>
    <score-table
      v-if="this.cardType == 0"
      :loading="loading"
      :flag="flag"
      :originalCardData="originalCardData"
      :scoreData="score"
      :cardType="3"
    ></score-table>
  </div>
</template>

<script>
import { CardView } from 'lxfintech-fe'
import ScoreTable from './components/ScoreTable.vue'
import { SCORE_DETAIL_SCHEMA } from './schema'
import { queryScore, exportScoreCard, queryScoreCard } from './api'

export default {
  name: 'score-card-detail',
  data() {
    return {
      id: '',
      loading: false,
      flag: null,
      originalData: null,
      score: null,
      SCORE_DETAIL_SCHEMA,
      column: { xxl: 3, xl: 3, lg: 2, md: 1, sm: 1, xs: 1 },
      cardType: '',
      originalCardData: [],
      // scoreData: [],
    }
  },
  created() {
    const autoScoreType = this.$route.params.recordId.autoScoreType
    this.cardType = autoScoreType

    const recordId = this.$route.params.recordId.id
    this.id = recordId
    recordId && this._queryScore(recordId)
  },
  methods: {
    async _queryScore(id) {
      try {
        this.loading = true
        if (this.cardType != 0) {
          const { data } = await queryScore(id)
          Object.assign(this, data)
          this.loading = false
        } else {
          const { data } = await queryScoreCard(id)
          Object.assign(this, data)
          this.loading = false
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    _exportScoreCard() {
      exportScoreCard(this.id)
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  components: {
    CardView,
    ScoreTable,
  },
}
</script>

<style lang="less" scoped></style>
